import {CheckOutlined, CloseOutlined, LineOutlined} from '@ant-design/icons';
import {Input} from 'antd';
import React, {useMemo, useState} from 'react';
import {formatCnpj, isValidCnpj, parseCnpj} from '../../util/cnpj';

export default function InputCnpj({onBlur, onChange, onFocus, value, suffix, ...props}) {
  const [editing, setEditing] = useState(false);
  const formattedValue = useMemo(() => formatCnpj(value), [value]);
  const isValid = useMemo(() => isValidCnpj(value), [value]);

  const fireChange = newValue => {
    if (newValue === value)
      return;
    if (typeof onChange === 'function')
      onChange(newValue);
  };
  const handleBlur = e => {
    setEditing(false);
    if (typeof onBlur === 'function')
      onBlur(e);
  };
  const handleChange = e => fireChange(parseCnpj(e.target.value));
  const handleFocus = e => {
    setEditing(true);
    const target = e.target;
    setImmediate(() => target.setSelectionRange(0, target.value.length));
    if (typeof onFocus === 'function')
      onFocus(e);
  };
  const handlePaste = e => {
    e.preventDefault();
    fireChange(parseCnpj(e.clipboardData.getData('text')));
  };

  const suffix2 = !value ?
      <LineOutlined /> :
      isValid ?
          <CheckOutlined className="success" /> :
          <CloseOutlined className="error" />;

  return (
      <Input
          maxLength={editing ? 14 : undefined}
          onBlur={handleBlur}
          onChange={handleChange}
          onFocus={handleFocus}
          onPaste={handlePaste}
          suffix={suffix ?? suffix2}
          value={editing ? value : formattedValue}
          {...props}
      />
  );
}
